import './helpers.js';
import { e as registerComponent, u as use } from './plugins-4daf8ef8.js';
import 'vue';
import { s as script } from './Field-b930e103.js';
export { s as OField } from './Field-b930e103.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, script);
  }

};
use(Plugin);

export default Plugin;
